<div class="material-symbols-outlined weather-icon"
     [ngClass]="[size, class()]">{{ path }}</div>

